const ToolTipTexts = {
    price: "The base price of your Venuely reservation is based on the hourly or fixed rate multiplied by the number of days set by the Host.",
    cleaningFee: "Charged by some Hosts to cover the cost of cleaning their space.",
    serviceFee: "Guest service fee charged by Veneuly—this provides 24/7 community support and helps everything run smoothly.",
    discount: "Some Hosts may provide a certain percentage of discount if your reservation is longer than 8+ hours"
}

const ToolTipMain = (text) => <span style={{ color: "#777", fontSize: 12, fontWeight: 'bold' }}>{text}</span>

export { ToolTipMain, ToolTipTexts }